import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty, isEqual } from 'lodash';
import { Loader } from '@components/common';
import CoreTable from './CoreTable';

class Table extends Component {
	shouldComponentUpdate = ({
		columns, data, sortedColumn, rowKey, asc, loading, smallLoading, updatingPaymentStatus,
	}) => {
		const lastProps = this.props;

		return (
			!isEqual(columns, lastProps.columns)
			|| !isEqual(data, lastProps.data)
			|| !isEqual(sortedColumn, lastProps.sortedColumn)
			|| !isEqual(rowKey, lastProps.rowKey)
			|| !isEqual(asc, lastProps.asc)
			|| !isEqual(loading, lastProps.loading)
			|| !isEqual(smallLoading, lastProps.smallLoading)
			|| !isEqual(updatingPaymentStatus, lastProps.updatingPaymentStatus)
		);
	}

	render() {
		const {
			data,
			loading,
			containerClassName,
			smallLoading,
			columns,
			className,
			sortedColumn,
			rowKey,
			asc,
			isReceiptTable,
			onSortColumn,
			onClickRow,
			updatingPaymentStatus,
		} = this.props;

		return (
			<div className={`table-container ${containerClassName}`}>
				<CoreTable
					data={data}
					columns={columns}
					className={className}
					sortedColumn={sortedColumn}
					rowKey={rowKey}
					asc={asc}
					onSortColumn={onSortColumn}
					onClickRow={onClickRow}
					isReceiptTable={isReceiptTable}
				/>
				<div className={classNames('empty-state', 'text-gray-light', { hidden : !isEmpty(data) })}>
					No items.
				</div>
				<Loader
					active={loading}
					size={smallLoading ? 'small' : undefined}
				/>
				<If condition={updatingPaymentStatus.loading && updatingPaymentStatus.selected > 1}>
					<div className="payment-status-update text-center">
						<strong>{`Updating ${updatingPaymentStatus.updated + 1}/${updatingPaymentStatus.selected}`}</strong>
					</div>
				</If>
			</div>
		);
	}
}

Table.propTypes = {
	data                  : PropTypes.array,
	loading               : PropTypes.bool,
	containerClassName    : PropTypes.string,
	smallLoading          : PropTypes.bool,
	columns               : PropTypes.array,
	className             : PropTypes.string,
	sortedColumn          : PropTypes.string,
	rowKey                : PropTypes.string,
	asc                   : PropTypes.bool,
	isReceiptTable        : PropTypes.bool,
	onSortColumn          : PropTypes.func,
	onClickRow            : PropTypes.func,
	updatingPaymentStatus : PropTypes.shape({
		loading  : PropTypes.bool,
		updated  : PropTypes.number,
		selected : PropTypes.number,

	}),
};

Table.defaultProps = {
	data                  : [],
	loading               : false,
	containerClassName    : '',
	smallLoading          : false,
	columns               : [],
	className             : undefined,
	sortedColumn          : 'Date',
	rowKey                : 'rowId',
	asc                   : false,
	isReceiptTable        : false,
	onSortColumn          : undefined,
	onClickRow            : undefined,
	updatingPaymentStatus : {
		loading  : false,
		updated  : 0,
		selected : 0,

	},
};

export default Table;
